import { z } from "zod/v4";
import { DraftReturnSchema } from "../draft-return/draft-return";
import { ReturnProductSchema } from "../draft-return/draft-return-items";
import { offeringSelectionSchema } from "../extended-warranty";
import { PurchaseChannel } from "../warranties";

export const WARRANTY_REGISTRATION_PREFIX = "WTY";

const productVariantResponseSchema = z.object({
  type: z.enum(["images", "text_area", "multiple_choice", "videos"]),
  value: z.union([z.string(), z.array(z.string())]),
  message: z.string(),
});

export type ProductVariantResponse = z.infer<
  typeof productVariantResponseSchema
>;

const sourceSchema = z.object({
  purchaseChannel: z.enum(PurchaseChannel),
  orderId: z.string().nullish(),
  referenceId: z.string().nullish(),
  channelName: z.string().nullish(),
});

// TODO: Reconcile with SourceDetails
export type RegistrationSource = z.infer<typeof sourceSchema>;

const warrantyRegistrationAccountSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  address: z.object({
    street1: z.string(),
    street2: z.string(),
    state: z.string(),
    city: z.string(),
    country: z.string(),
    zip: z.string(),
  }),
});

export type WarrantyRegistrationAccount = z.infer<
  typeof warrantyRegistrationAccountSchema
>;

export const submitWarrantyRegistrationSchema = {
  name: "submitWarrantyRegistration" as const,
  input: z.object({
    draftReturnId: z.string().optional(),
    notifyCustomer: z.boolean().default(false),
    product: ReturnProductSchema,
    responses: z.array(productVariantResponseSchema).readonly().nullish(),
    account: warrantyRegistrationAccountSchema,
    offeringSelection: offeringSelectionSchema.nullish(),
    paymentToken: z.string().nullish(),
    optInMarketing: z.boolean(),
    source: sourceSchema.nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    draftReturn: DraftReturnSchema.nullish(),
    warrantyRegistrationId: z.string().nullish(),
    // Disabling login because of security concerns. Will be re-enabled when we have a OTP in registration.
    // customerToken: z.string().nullish(),
    // customer: z
    //   .object({
    //     name: z.string(),
    //     email: z.string(),
    //     customerId: z.string().nullish(),
    //     firstName: z.string().nullish(),
    //     lastName: z.string().nullish(),
    //   })
    //   .nullish(),
  }),
};

export type SubmitWarrantyRegistrationInput = z.infer<
  (typeof submitWarrantyRegistrationSchema)["input"]
>;

export type SubmitWarrantyRegistrationOutput = z.infer<
  (typeof submitWarrantyRegistrationSchema)["output"]
>;
